import { Component, inject, OnInit } from '@angular/core';
import {  RouterOutlet } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ToastModule } from 'primeng/toast';
import { LayoutService } from './layout/service/layout.service';
import { AppLoadingOverlayComponent } from './shared/components/ui/loading-overlay/loading-overlay.component';
import { ConfirmationService } from 'primeng/api';
import { UserStore } from './core/auth/user/store/user.store';
import { Title } from '@angular/platform-browser';
import { BrandingService } from './core/branding/branding.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, AppLoadingOverlayComponent],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  oidcSecurityService = inject(OidcSecurityService);
  confirmationService = inject(ConfirmationService);
  userStore = inject(UserStore);
  layoutService = inject(LayoutService);
  brandingService = inject(BrandingService);
  private title = inject(Title);

  ngOnInit(): void {
    this.layoutService.updateBodyBackground('noir')
    this.title.setTitle(this.brandingService.branding()?.label || 'Loading...');
  }
}
